import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  mailDeliveryItemID: 0,
  events: [],
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'description',
      label: 'Description',
      aria: 'Description',
      width: '55%',
      sortable: true,
      searchable: true
    },
    {
      field: 'eventDate',
      date: true,
      label: 'Event Time',
      aria: 'Event Time',
      width: '40%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    formRow: {
      padding: '10px',
      whiteSpace: 'nowrap'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
